/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialSupportDemoCompanySummaryDto } from '../../models/financial-support-demo-company-summary-dto';

export interface FinancialSupportDemoControllerFindAll$Params {
}

export function financialSupportDemoControllerFindAll(http: HttpClient, rootUrl: string, params?: FinancialSupportDemoControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FinancialSupportDemoCompanySummaryDto>>> {
  const rb = new RequestBuilder(rootUrl, financialSupportDemoControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FinancialSupportDemoCompanySummaryDto>>;
    })
  );
}

financialSupportDemoControllerFindAll.PATH = '/api/financial-support/demo-companies';
